import { Component, OnInit, ViewChild } from '@angular/core';
 
@Component({
  selector: 'app-stroy',
  templateUrl: './stroy.component.html',
  styleUrls: ['./stroy.component.scss']
})
export class StroyComponent implements OnInit {
  showArrows: boolean;
  autoplay: number | boolean;
  isAutoplay: boolean;
  arrowLeftLabel: string;
  arrowRightLabel: string;
  
  constructor() {
    // this.isLoading = true;
    // this.backdrops = [];
    this.reset();
    // this.logs = [];
  }
  
  reset(): void {
    // this.showCustomArrows = false;
    this.showArrows = true;
    this.isAutoplay = true;
    this.autoplay = 5000;
    // this.showBullets = true;
    this.arrowLeftLabel = 'left';
    this.arrowRightLabel = 'right'; 
    // this.type = 'slider';
    // this.startAt = 0;
    // this.perView = 3;
    // this.isCenter = false;
    // this.focusAt = 0;
    // this.gap = 10;
    // this.isAutoplay = false;
    // this.autoplay = 1000;
    // this.hoverpause = true;
    // this.keyboard = true;
    // this.bound = false;
    // this.isSwipeThreshold = true;
    // this.swipeThreshold = 80;
    // this.isDragThreshold = true;
    // this.dragThreshold = 120;
    // this.isPerTouch = false;
    // this.perTouch = 3;
    // this.touchRatio = 0.5;
    // this.touchAngle = 45;
    // this.animationDuration = 400;
    // this.rewind = true;
    // this.rewindDuration = 800;
    // this.animationTimingFunc = 'cubic-bezier(0.165, 0.840, 0.440, 1.000)';
    // this.direction = 'ltr';
  }


  ngOnInit(): void {
  }
   
  
  // config = { 
  //   animated: true,
  //   keyboard: true,
  //   backdrop: true,
  //   class:'at-addfilemodal'
  // };

}
